import React from 'react';

import { checkTranslation, imageAddress, translate } from '../utils/useful';
import FixedView from './FixedView';
import FilterEditorModal from './inputs/FilterEditorModal';
// import GroupedBy from './inputs/GroupedBy';
// import SortedBy from './inputs/SortedBy';
import StackedField from './inputs/StackedField';
import Fields from './inputs/CustomizeFields';

import SidebarView from './SidebarView';
import IntractionActionsList from './IntractionActionsList';
import AddFieldsList from './AddFieldsList';
import AddViewList from './AddViewList';
import HttpServices from '../utils/Http.services';
import ImportModal from './modals/ImportModal';
import ExportModal from './modals/ExportModal';
import PrintModal from './modals/PrintModal';
import Collapsible from 'react-collapsible';

class ViewsIntractionActions extends React.Component {

  state = {
    data: [
      { title: "dsfsdf", shortcut: "wrcv" }
    ],
    main: false,

    list: [],
    currentFrame: '',
    currentFrameName: '',
    stackedView: true,
  }


  componentDidMount() {
    let data = {}
    data.applet = this.props.applet
    let list = this.state.list
    console.log('datafilter',data)
    HttpServices.request('getFrames', data, (fetchResult, fetchError) => {

      if (fetchError) {
        // console.log('errrrror', fetchError)
        return
      }
      // fetchResult.info.map((element, index) => {
      //     console.log('elementelement', element)
      // })
      list = fetchResult.info
      console.log('result23121', fetchResult.info)
      this.setState({ list, currentFrameName: fetchResult.info[0].name })
    })
    // this.formView.addEventListener('click', (e) => {
    //     let inside = e.target.closest('')

    // })
  }

  componentDidUpdate(prevProps) {
    if (this.props.checkPropsStacked != prevProps.checkPropsStacked) {
      console.log('dfsbsdbsdbf')
      this.setState({ stackedView: false }, () => {
        this.setState({ stackedView: true })
      })
    }
  }
  changeView = (prop,All) => {
    this.props.changeView(prop,All)
    this.setState({viewAll:All})
    if(!All?.settings?.stacked){
      this.stackedFixedView.stacedModal.showModal()
    }
    this.viewFixedView.hideView()

  }

  openAddField = () => {
    this.addField.openSidebar()
  }
  hdieAddField = () => {
    this.addField.hideModal()
  }

  openAddView = () => {
    this.addView.openSidebar()
  }
  hideAddView = () => {
    this.addView.hideModal()
  }
  addFieldInput = (data) => {
    HttpServices.request('addFieldFrame', data, (fetchResult, fetchError) => {
      // console.log(this.props.currentFrame)
      // console.log(fetchResult.info)
      let currentFrame = this.props.currentFrame
      currentFrame.fields = fetchResult.info.fields
      this.props.setData('currentFrame', currentFrame)
      this.setState({ stackedView: false }, () => {
        this.setState({ stackedView: true })
      })

      this.hdieAddField()
    })
  }
  changeFrame = (prop) => {
    this.setState({ currentFrameName: prop.name }, () => {
      this.props.setData('currentFrame', prop)
      this.props.fetchData()
      return prop.headers
    })

  }

  changeCollapse = () => {
    let main = this.state.main
    this.setState({ main: !main })
  }
  changePageCollapse = () => {
    let mainPage = this.state.mainPage
    this.setState({ mainPage: !mainPage })
  }

  setStackedKey = (key) => {
    this.setState({ stackedKey: key })
    if (this.props.setStackedKey) {
      this.props.setStackedKey(key)
    }
  }

  render() {
    let { list } = this.state

    return (

      <div className='' style={{ background: this.props.background ?? '#fff', position: 'sticky', top: 0, zIndex: 2 }}>
        <div className='w-100 px-0  flexc ' style={{ backgroundColor: '' }}>
          <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='flexc p-2'>
            <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-bg'>
              <div className='flexcc mrd-1'>
                <img className={this.props.invert ? '' : 'invert'} width={18} src="/assets/icons/applets/database/frame-white.svg" />
              </div>
              {/* {console.log('this.props.currentFrame', this.props.currentFrame)} */}
              <p className='font-size-14 ' style={{ color: this.props.color ?? '#000' }}>{checkTranslation(this.props.currentFrame?.name) ?? translate('Frames')}</p>
            </div>
          </button>

          <button onClick={() => this.viewFixedView.showView()} ref={el => this.viewNode = el} className='flexc py-2 px-1' style={{}}>
            <div className='flexcc px-2 py-1 br-5 light-blur-hover'>
              <p className='font-size-14 ' style={{ color: this.props.color ?? '#000' }}>{translate('Views')}</p>
              <div className='br-20 mld-1 flexcc' style={{ color: this.props.color ?? '#000', backgroundColor: 'rgba(255, 255, 255, 0.1)', height: 20, minWidth: 20 }}>
                <p className='text-smaller text-semibold'>3</p>
              </div>
            </div>
          </button>

          <div className='flexc py-2 px-1' ref={el => this.dataNode = el}>
            <button onClick={() => this.dataOptionsList.showView()} className='flexcc px-2 py-1 br-5 light-blur-hover' style={{}}>
              <p className='font-size-14 ' style={{ color: this.props.color ?? '#000' }}>{translate('Data')}</p>
            </button>
          </div>


          {/* <div className='opacity-9'>
            <button onClick={() => this.viewFixedView.showView()} ref={el => this.editNode = el} className='flexc  py-2 pld-4' style={{}}>
              <p className='font-size-14 ' style={{ color: this.props.color ?? '#000' }}>Edit</p>
            </button>
          </div> */}


          <div className='flexc py-2 px-1' ref={el => this.toolsNode = el}>
            <button onClick={() => this.toolsOptionsList.showView()} className='flexcc px-2 py-1 br-5 light-blur-hover' style={{}}>
              <p className='font-size-14 ' style={{ color: this.props.color ?? '#000' }}>{translate('Tools')}</p>
            </button>
          </div>


          <div className='flexc py-2 px-1' ref={el => this.settingsNode = el}>
            <button onClick={() => this.settingsOptionsList.showView()} className='flexcc px-2 py-1 br-5 light-blur-hover' style={{}}>
              <p className='font-size-14 ' style={{ color: this.props.color ?? '#000' }}>{translate('Settings')}</p>
            </button>
          </div>



          <div>
            {/* <button className='flexc br-4 py-2 px-2 opacity-9' onClick={() => this.filterFixedView.filterEditor.open()} ref={el => this.filterBut = el} >
              <div className='flexcc mrd-2 '>
                <img className={this.props.invert ? 'invert' : ''} src="/assets/icons/useful/filter.png" height={'12px'} />
              </div>
              <p className='font-size-14' style={{ color: this.props.color ?? '#000' }}>{translate("Filter")}</p>


            </button> */}

            {/* <FixedView width={this.props.width} zIndex={10} ref={el => this.filterFixedView = el} nodeRef={this.filterBut} xOffset={-20} topOffset={0} maxWidth={320} > */}
            {/* <SidebarView width={this.props.width} ref={el => this.filterFixedView = el} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '60%', lg: "50%", xl: "40%" }} > */}
            {/* <div className='bg-white box-shadow-20 br-4  py-1'> */}
            <FilterEditorModal headers={this.props.headers} ref={el => this.filterFixedView = el} width={this.props.width} />
            {/* </div> */}
            {/* </SidebarView> */}
            {/* </FixedView> */}

          </div>




          {/* <div>
            <button className='flexc br-4 py-2 px-2 opacity-9' onClick={() => this.groupFixedView.showView()} ref={el => this.groupBut = el} >
              <div className='flexcc mrd-2 '>
                <img className={this.props.invert ? 'invert' : ''} src="/assets/icons/table.png" height={'12px'} />
              </div>
              <p className='font-size-14' style={{ color: this.props.color ?? '#000' }}>{translate("Group")}</p>


            </button>

            <FixedView width={this.props.width} zIndex={10} ref={el => this.groupFixedView = el} nodeRef={this.groupBut} xOffset={-20} topOffset={0} maxWidth={320} >
              <div className='bg-white box-shadow-20 br-4  py-1'>
                <GroupedBy headers={this.props.headers} width={this.props.width} />
              </div>
            </FixedView>

          </div> */}


          {/* <div>
            <button className='flexc br-4 py-2 px-2 opacity-9' onClick={() => this.sortFixedView.showView()} ref={el => this.sortBut = el} >
              <div className='flexcc mrd-2 '>
                <img className={this.props.invert ? 'invert' : ''} src="/assets/icons/useful/sort.png" height={'12px'} />
              </div>
              <p className='font-size-14' style={{ color: this.props.color ?? '#000' }}>{translate("Sort")}</p>


            </button>

            <FixedView width={this.props.width} zIndex={10} ref={el => this.sortFixedView = el} nodeRef={this.sortBut} xOffset={-20} topOffset={0} maxWidth={320} >
              <div className='bg-white box-shadow-20 br-4  py-1'>
                <SortedBy headers={this.props.headers} width={this.props.width} />
              </div>
            </FixedView>

          </div> */}


          <div>
            <button className='flexc br-4 py-2 px-2 opacity-9' onClick={() => this.stackedFixedView.StackedField.open()} ref={el => this.stackBut = el} >
              <div className='flexcc mrd-2 '>
                <img className={this.props.invert ? 'invert' : ''} src="/assets/icons/useful/stack.png" height={'12px'} />
              </div>
              <p className='font-size-14' style={{ color: this.props.color ?? '#000' }}>{translate("Stack")}</p>
            </button>
            {/* <SidebarView width={this.props.width} ref={el => this.stackedFixedView = el} nodeRef={this.stackBut} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '60%', lg: "50%", xl: "40%" }} > */}
            {this.state.stackedView &&
              <div className='bg-white box-shadow-20 br-4 h-100'>
                <StackedField setData={this.props.setData} defaultStackedKey={this.state.viewAll?.settings?.stacked} currentFrame={this.props.currentFrame} view={this.props.view} viewAll={this.state.viewAll ?? null} headers={this.props.headers} ref={el => this.stackedFixedView = el} width={this.props.width} changeValue={this.setStackedKey} />
              </div>
            }
          </div>

          <div>
            {/* <button className='flexc br-4 py-2 px-2 opacity-9' onClick={() => this.FieldsView.open()} ref={el => this.groupBut = el} >
              <div className='flexcc mrd-2 '>
                <img className={this.props.invert ? 'invert' : ''} src="/assets/icons/table.png" height={'12px'} />
              </div>
              <p className='font-size-14' style={{ color: this.props.color ?? '#000' }}>{translate("Customize")}</p>
            </button> */}
            <SidebarView width={this.props.width} zIndex={10} ref={el => this.FieldsView = el} widthCondition={{ xs: "60%", sm: "50%", md: '40%', lg: "30%", xl: "30%" }}>
              <Fields headers={this.props.headers} width={this.props.width} />
            </SidebarView>
          </div>



          {/* FRAMES */}
          <FixedView width={this.props.width} zIndex={10} ref={el => this.framesOptionsList = el} nodeRef={this.framesNode} xOffset={this.props.language == 'fa' ? 102 : -17} bottomOffset={27} topOffset={-7} maxWidth={200} >
            <div className='bg-white br-10 p-2 shadow-3 sc-gray2 ' style={{ maxHeight: '350px', overflow: 'auto' }}>
              <div className=' mb-2'>
                <IntractionActionsList data={{ title: "{{lang}}Pin Frames", icon: "/assets/icons/applets/database/pin-purple.svg" }} />
                {/* <IntractionActionsList data={{ title: "Colection", icon: "/assets/icons/applets/database/stages-purple.svg" }} /> */}
              </div>
              <div className='white-bg py-2 ' style={{ borderTop: '1px solid #eee', borderBottom: '1px solid #eee', }}>
                <button className='flexcb p-2 w-100 hover-gray br-10' onClick={() => this.changeCollapse()} >
                  <div className='flexc'>
                    <img className='mrd-2 flexcc' width={18} src='/assets/icons/applets/database/stages-purple.svg' />
                    <p className='main-c3'>{translate('Collection')}</p>
                  </div>
                  <button>
                    <img width={22} className={'flexcc ' + (this.state.main ? 'rotate-180' : '')} src='/assets/icons/applets/database/arrow-up-purple.svg' />
                  </button>
                </button>
                <Collapsible open={this.state.main} transitionTime={100}>
                  <div className='mt-1 br-10' style={{ backgroundColor: '#F6F6F6', overflow: 'hidden' }}>
                    <div className=''>
                      <button style={{ borderBottom: '1px solid #eee' }} className='flexcb purple-btn py-2 px-2 w-100' onClick={() => this.props.addNewForm()} >
                        <p>{translate('Create New')}</p>
                        <p className='font-size-18'>+</p>
                      </button>
                    </div>
                    {list?.map((prop, index) => {
                      let name = 'form'
                      return (
                        <div className='bb-gray pt-2'>
                          <button className={'flexcb p-2 w-100 hover-gray2'} style={{ backgroundColor: (prop._id == this.props.currentFrame._id ? '#E0E0EB' : '') }} onClick={() => this.changeFrame(prop)} >
                            <div className=' flexc'>
                              {/* <img className='br-50 flexcc mrd-2' width={24} height={24} src={imageAddress('', "applet")} /> */}
                              <p className='text-left w-100' style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", }}>{checkTranslation(prop.name)}</p>
                            </div>
                            {prop._id == this.props.currentFrame._id &&
                              <div className='flexcc'>
                                <img width={18} src='/assets/icons/check-purple.svg' />
                              </div>
                            }
                          </button>
                        </div>
                      )
                    })}
                  </div>
                </Collapsible>
              </div>
              <div className='white-bg py-2 ' style={{ borderTop: '1px solid #eee', borderBottom: '1px solid #eee', }}>
                <button className='flexcb p-2 w-100 hover-gray br-10' onClick={() => this.changePageCollapse()} >
                  <div className='flexc'>
                    <img className='mrd-2 flexcc' width={18} src='/assets/icons/applets/database/stages-purple.svg' />
                    <p className='main-c3'>{translate('Pages')}</p>
                  </div>
                  <button>
                    <img width={22} className={'flexcc ' + (this.state.main ? 'rotate-180' : '')} src='/assets/icons/applets/database/arrow-up-purple.svg' />
                  </button>
                </button>
                <Collapsible open={this.state.mainPage} transitionTime={100}>
                  <div className='mt-1 br-10' style={{ backgroundColor: '#F6F6F6', overflow: 'hidden' }}>
                    <div className=''>
                      <button style={{ borderBottom: '1px solid #eee' }} className='flexcb purple-btn py-2 px-2 w-100' onClick={() => this.props.addNewPage()} >
                        <p>{translate('Create New')}</p>
                        <p className='font-size-18'>+</p>
                      </button>
                    </div>
                    {list?.map((prop, index) => {
                      let name = 'form'
                      return (
                        <div className='bb-gray pt-2'>
                          <button className={'flexcb p-2 w-100 hover-gray2'} style={{ backgroundColor: (prop._id == this.props.currentFrame._id ? '#E0E0EB' : '') }} onClick={() => this.changeFrame(prop)} >
                            <div className=' flexc'>
                              {/* <img className='br-50 flexcc mrd-2' width={24} height={24} src={imageAddress('', "applet")} /> */}
                              <p className='text-left w-100' style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", }}>{checkTranslation(prop.name)}</p>
                            </div>
                            {prop._id == this.props.currentFrame._id &&
                              <div className='flexcc'>
                                <img width={18} src='/assets/icons/check-purple.svg' />
                              </div>
                            }
                          </button>
                        </div>
                      )
                    })}
                  </div>
                </Collapsible>
              </div>
              {/* <IntractionActionsList data={{ title: "{{lang}}Pages", icon: "/assets/icons/applets/database/pages-purple.svg" }} /> */}
              <IntractionActionsList data={{ title: "{{lang}}User Perspective", icon: "/assets/icons/applets/database/user.svg" }} />
            </div>
          </FixedView>


          {/* VIEWS */}
          <FixedView width={this.props.width} zIndex={10} ref={el => this.viewFixedView = el} nodeRef={this.viewNode} xOffset={this.props.language == 'fa' ? 104 : -17} bottomOffset={27} topOffset={-7} maxWidth={200} >
            <div className='bg-white br-10 p-2 shadow-3'>
              <div className='mb-2'>
                {this.props.currentFrame?.views?.map((prop, index) => {
                  return (
                    <button onClick={() => this.changeView(prop.type, prop)} className='flexc w-100 hover-gray p-2 br-10'>
                      <img src={'/assets/icons/applets/database/' + prop.type + '.svg'} width={18} />
                      <p className='font-size-12 mld-3 main-c3'>{checkTranslation(prop.name)}</p>
                    </button>
                  )
                })}
              </div>
              <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                <button className='flexc p-2 br-10 hover-gray w-100' onClick={() => this.openAddView()}>
                  <img width={22} src='/assets/icons/applets/database/plus-purple.svg' />
                  <p className='font-size-14 mld-2' style={{ color: "#4E4CCC" }}>{translate('Create New View')}</p>
                </button>
              </div>
            </div>
          </FixedView>


          {/* Data */}
          <FixedView width={this.props.width} zIndex={10} ref={el => this.dataOptionsList = el} nodeRef={this.dataNode} xOffset={this.props.language == 'fa' ? 130 : -17} bottomOffset={27} topOffset={-7} maxWidth={200} >
            <div className='bg-white br-10 p-2 shadow-3' >
              <div className='w-100 pb-2' style={{ borderBottom: "1px solid #eee" }}>
                <input placeholder={translate('Search')} className='py-1 px-2 br-5 w-100' style={{ backgroundColor: '#F2F2F7', border: '1px solid #F2F2F7' }} />
              </div>
              <div className='sc-gray pt-2 ' style={{ overflow: 'auto', maxHeight: '300px' }}>
                <IntractionActionsList data={{ title: "{{lang}}New Record", icon: "/assets/icons/applets/database/record-purple.svg" }} />
                <IntractionActionsList onClick={this.openAddField} data={{ title: "{{lang}}Add Field", icon: "/assets/icons/applets/database/addfield-purple.svg" }} />
                <IntractionActionsList data={{ title: "{{lang}}Customize Fields", icon: "/assets/icons/applets/database/cutomizefield-purple.svg" }} />
                <IntractionActionsList data={{ title: "{{lang}}Advanced Search", icon: "/assets/icons/applets/database/advancesearch.svg.svg" }} />
                <IntractionActionsList data={{ title: "{{lang}}Filter", icon: "/assets/icons/applets/database/filter-purple.svg", shortcut: "CNT+F" }} />
                <IntractionActionsList data={{ title: "{{lang}}Saved Filters", icon: "/assets/icons/applets/database/savefilter-purple.svg" }} />
                <IntractionActionsList data={{ title: "{{lang}}Group By", icon: "/assets/icons/applets/database/groupby-purple.svg" }} />
                <IntractionActionsList data={{ title: "{{lang}}Sort By", icon: "/assets/icons/applets/database/sorthby-purple.svg" }} />
              </div>
            </div>
          </FixedView>


          {/* Tools */}
          <FixedView width={this.props.width} zIndex={10} ref={el => this.toolsOptionsList = el} nodeRef={this.toolsNode} xOffset={this.props.language == 'fa' ? 150 : -17} bottomOffset={27} topOffset={-7} maxWidth={200} >
            <div className='bg-white br-10 p-2 shadow-3'>
              <div className='mb-2'>
                <IntractionActionsList data={{ title: "{{lang}}Inbox", icon: "/assets/icons/applets/database/inbox.svg" }} />
                <IntractionActionsList data={{ title: "{{lang}}Activity Log", icon: "/assets/icons/applets/database/activity.svg" }} />
                <IntractionActionsList data={{ title: "{{lang}}Communications", icon: "/assets/icons/applets/database/comunication.svg" }} />
              </div>
              <div className='pt-2 mb-2' style={{ borderTop: "1px solid #eee" }}>
                <IntractionActionsList data={{ title: "{{lang}}Conditional format", icon: "/assets/icons/applets/database/format.svg" }} />
                <IntractionActionsList onClick={() => this.ImportModal.modal.showModal()} data={{ title: "{{lang}}Import", icon: "/assets/icons/applets/database/import.svg", shortcut: "CNT+F" }} />
                <IntractionActionsList onClick={() => this.ExportModal.modal.showModal()} data={{ title: "{{lang}}Export", icon: "/assets/icons/applets/database/export.svg" }} />
                <IntractionActionsList onClick={() => this.PrintModal.modal.showModal()} data={{ title: "{{lang}}Print", icon: "/assets/icons/applets/database/print-purple.svg" }} />
              </div>
              <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                <IntractionActionsList data={{ title: "{{lang}}Make a copy", icon: "/assets/icons/applets/database/copy.svg" }} />
              </div>

              {/* <button className="flexc w-100 pt-2" style={{ borderTop: '1px solid #eee' }}>
                <img height={16} width={16} className="opacity-9" src="/assets/icons/useful/setting-1.png" />
                <p className="text-small mld-3" style={{ color: '#2a2e34' }}>Saved Filters</p>
              </button> */}
            </div>
          </FixedView>


          {/* SETTINGS */}
          <FixedView width={this.props.width} zIndex={10} ref={el => this.settingsOptionsList = el} nodeRef={this.settingsNode} xOffset={this.props.language == 'fa' ? 120 : -17} bottomOffset={27} topOffset={-7} maxWidth={200} >
            <div className='bg-white br-10 p-2 shadow-3'>
              <div className='mb-2'>
                <IntractionActionsList data={{ title: "{{lang}}Stages", icon: "/assets/icons/applets/database/stages-purple.svg" }} />
                <IntractionActionsList data={{ title: "{{lang}}Actions", icon: "/assets/icons/applets/database/bolt-purle.svg" }} />
                <IntractionActionsList data={{ title: "{{lang}}Automations", icon: "/assets/icons/applets/database/automation-purple.svg" }} />
                <IntractionActionsList data={{ title: "{{lang}}Permissions", icon: "/assets/icons/applets/database/key-purple.svg" }} />
              </div>
              <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                <IntractionActionsList data={{ title: "{{lang}}Open Settings", icon: "/assets/icons/applets/database/setting-purple.svg" }} />
              </div>
            </div>
          </FixedView>
        </div>
        <SidebarView width={this.props.width} zIndex={10} ref={el => this.addField = el} widthCondition={{ xs: "60%", sm: "50%", md: '35%', lg: "35%", xl: "25%" }}>
          <AddFieldsList addField={this.addFieldInput} hdieAddField={this.hdieAddField} currentFrame={this.props.currentFrame} />
        </SidebarView>
        <SidebarView width={this.props.width} zIndex={10} ref={el => this.addView = el} widthCondition={{ xs: "60%", sm: "50%", md: '35%', lg: "35%", xl: "25%" }}>
          <AddViewList currentFrame={this.props.currentFrame} setData={this.props.setData} hideAddView={this.hideAddView} />
        </SidebarView>
        <PrintModal width={this.props.width} closeModal={() => this.PrintModal.modal.hideModal()} ref={el => this.PrintModal = el} data={this.state?.course} />
        <ImportModal width={this.props.width} closeModal={() => this.ImportModal.modal.hideModal()} ref={el => this.ImportModal = el} data={this.state?.course} applet={this.props.applet} />
        <ExportModal width={this.props.width} closeModal={() => this.ExportModal.modal.hideModal()} ref={el => this.ExportModal = el} data={this.state?.course} />
      </div>

    );
  }
}

export default ViewsIntractionActions;
